import { IonButton, IonButtons, IonContent, IonDatetime, IonDatetimeButton, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonModal, IonSelect, IonSelectOption, IonTitle, IonToolbar } from "@ionic/react";
import { Form, Formik } from "formik";
import { optionsOutline } from 'ionicons/icons';
import { useEffect, useRef, useState } from "react";
import * as Yup from 'yup';
import { DivH } from "../../../components/divh/styled";
import { Store, compareStoreWith } from "../../../dto/store/store";
import { PdvData, PdvFilter } from "../service";

export interface Paran {
   setData: any
   filter: PdvFilter
   allStoreP: Store[]
}

const Filter: React.FC<Paran> = ({ setData, filter, allStoreP }) => {
   const [open, setOpen] = useState(false)
   const formRef = useRef({} as any)
   const [allStores, setAllStores] = useState([] as Store[])

   useEffect(() => {
      if (open) {
         setAllStores(allStoreP)
      }
   }, [open, allStoreP])

   const closeModal = () => {
      setOpen(false);
   }

   const submit = async (values: PdvFilter) => {
      closeModal()
      setData({
         filter: {
            ...filter,
            ...values
         }
      } as PdvData)
   }

   const applyFilter = () => {
      if (formRef.current) {
         formRef.current.handleSubmit()
      }
   }

   const buildOrderByValues = () => {
      return [{ id: 'SALE', name: 'Venda' }
         , { id: 'COUPON', name: 'Cupom' }
         , { id: 'DESCOUNT', name: 'Desconto' }
         // , { id: 'CANCELLATION', name: 'Cancelamento' }
         , { id: 'ADDITION', name: 'Acrécimos ' }
         , { id: 'BIPS', name: 'Bips ' }
      ]
   }

   return (
      <>
         <IonButton color="light" onClick={() => setOpen(true)} >
            <IonIcon icon={optionsOutline} />
         </IonButton>

         <IonModal
            isOpen={open}
            onDidDismiss={closeModal}
            breakpoints={[0, 0.2, 0.5, 0.8, 1]}
            initialBreakpoint={0.5}
            backdropBreakpoint={0.2}
         >
            <IonHeader>
               <IonToolbar>
                  <IonButtons slot="start">
                     <IonButton color="light" onClick={() => setOpen(false)}>Cancelar</IonButton>
                  </IonButtons>

                  <IonTitle style={{ textAlign: 'center' }}>Filtro</IonTitle>

                  <IonButtons slot="end">
                     <IonButton color="light" strong={true} onClick={() => applyFilter()}>Aplicar</IonButton>
                  </IonButtons>
               </IonToolbar>
            </IonHeader>

            <IonContent>

               {/* Formulário de filtro */}
               <Formik
                  innerRef={formRef}
                  initialValues={filter}
                  onSubmit={submit}
                  validationSchema={
                     Yup.object().shape({
                        date: Yup.date().required(),
                        store: Yup.object().required(),
                        startHour: Yup.number().required(),
                        endHour: Yup.number().required(),
                     })
                  }
               >
                  {(propsForm) => (
                     <Form id='my-form'>
                        <IonList>
                           <IonItem>
                              <IonLabel>Dia :</IonLabel>
                              <IonDatetimeButton datetime="datetimeStart" />

                              <IonModal keepContentsMounted={true} >
                                 <IonDatetime
                                    id="datetimeStart"
                                    name="date"
                                    onIonChange={propsForm.handleChange}
                                    onIonBlur={propsForm.handleBlur}
                                    value={propsForm.values.date}
                                    locale="pt-BR"
                                    presentation={'date'}
                                    showDefaultButtons={true}
                                    style={{ width: '100%' }}
                                 />
                              </IonModal>
                           </IonItem>
                           <IonItem >
                              <IonLabel >Hora : </IonLabel>
                              <DivH style={{marginLeft: 'auto'}}> 
                                 <IonInput style={{width : '4em'}} type="number" min={1} max={23} 
                                    name="startHour"
                                    onIonChange={propsForm.handleChange}
                                    onIonBlur={propsForm.handleBlur}
                                    value={propsForm.values.startHour}
                                    />
                                 <label style={{color: 'grey', marginLeft: '0.5em', marginRight: '-0.5em'}}>até</label>
                                 <IonInput style={{width : '4em'}} type="number" min={1} max={23} 
                                    name="endHour"
                                    onIonChange={propsForm.handleChange}
                                    onIonBlur={propsForm.handleBlur}
                                    value={propsForm.values.endHour}
                                    />
                              </DivH>
                           </IonItem>

                           <IonItem style={{ marginRight: '1em' }}>
                              <IonLabel>Ordenar por </IonLabel>
                              <IonSelect
                                 value={propsForm.values.orderBy}
                                 name='orderBy'
                                 onIonChange={propsForm.handleChange}
                                 onIonBlur={propsForm.handleBlur}
                              // multiple={true}
                              >
                                 {buildOrderByValues().map((orderBy) => (
                                    <IonSelectOption key={orderBy.id} value={orderBy.id}>
                                       {orderBy.name}
                                    </IonSelectOption>
                                 ))}
                              </IonSelect>
                           </IonItem>

                           <IonItem style={{ marginRight: '1em' }}>
                              <IonLabel>Unidade</IonLabel>
                              <IonSelect
                                 value={propsForm.values.store}
                                 name='store'
                                 placeholder="Todas as lojas"
                                 compareWith={compareStoreWith}
                                 onIonChange={propsForm.handleChange}
                                 onIonBlur={propsForm.handleBlur}
                              >
                                 {allStores.map((store) => (
                                    <IonSelectOption key={store.id} value={store}>
                                       {store.name}
                                    </IonSelectOption>
                                 ))}
                              </IonSelect>
                           </IonItem>
                           {/* <IonToolbar>
                              <IonButtons slot="end" style={{ marginRight: '2em' }}>
                                 <IonButton onClick={() => { propsForm.setFieldValue('stores', []) }} >
                                    <IonIcon icon={squareOutline} />
                                 </IonButton>
                                 <IonButton onClick={() => { propsForm.setFieldValue('stores', allStores) }} >
                                    <IonIcon icon={checkmarkDoneOutline} />
                                 </IonButton>
                              </IonButtons>
                           </IonToolbar> */}
                        </IonList>
                     </Form>
                  )}
               </Formik>

            </IonContent>
         </IonModal>
      </>
   );
};

export default Filter;